import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Popup } from "../../../utils/Div";

export function FieldHint({ content }) {
  if (!content) return null;

  return (
    <span className="relative ml-1 inline-flex shrink-0 align-middle">
      <Popup content={content} textSize="xs">
        <InformationCircleIcon
          className="h-4 w-4 text-slate-400 hover:text-[#1463C7]"
          aria-hidden="true"
        />
      </Popup>
    </span>
  );
}

export function HintLabel({ children, hint }) {
  return (
    <span className="inline-flex items-center gap-0.5">
      <span>{children}</span>
      <FieldHint content={hint} />
    </span>
  );
}

export function HintField({ hint, children }) {
  return (
    <div className="relative">
      {hint ? (
        <div className="absolute right-0 top-0 z-10">
          <FieldHint content={hint} />
        </div>
      ) : null}
      {children}
    </div>
  );
}
